import _ from 'underscore'
import {
  get_attachment_token_path
} from '~/routes';

/*
AdaliaViewer is a quick in-browser viewer for files.

Requirements:
-------------
Common libraries:
jQuery, Underscore.js, Font Awesome

Other:
Rails-like window.I18n.t -function for string localisation.

Example:
--------
<a href="/url/to/a/file" 
    data-av="true" 
    data-av-content-type="application/pdf"
    data-av-title="Title for the file in preview (e.g. it's name)">
    Link text
</a>

Attributes:
-----------
data-av:                "true" indicates that the AdaliaViewer preview should be used when this link is clicked.
data-av-content-type:   (required) Tell AdaliaViewer how to display the file.
data-title:             (optional) Title text in the preview. If not given the link text will be used.

Notes:
------
Displays image files that are supported by browser and other documents that
are assumed to be convertable to PDF (see AdaliaViewer.ContentTypes.document).
Expects the file url to provide the files in PDF format (except the images).

If content type is not supported a download link will be provided.

Supported content types are based on what LibreOffice Writer and Impress
can convert to PDF. Consider using that on server side for PDF-conversion.
*/

window.I18n = window.I18n || {t: function() {}}; // Prevent errors in case it's missing

var AdaliaViewer = {

    links: [],
    currentIndex: 0,

    init: function() {
        jQuery('body > .adalia-viewer').remove();
        jQuery('body').append(AdaliaViewer.Templates.viewer);

        jQuery('body').
            off('click', '[data-av="true"]', AdaliaViewer.open).
            on('click', '[data-av="true"]', AdaliaViewer.open);

        jQuery('body .adalia-viewer').
            on('click', 'a.close', AdaliaViewer.close).
            on('click', '.navigation.prev a', AdaliaViewer.prev).
            on('click', '.navigation.next a', AdaliaViewer.next).
            on('click', '.file-selector > a.current', AdaliaViewer.toggleFileSelector).
            on('click', '.file-selector li a', AdaliaViewer.selectFile);

        jQuery('body').
            off('keydown', AdaliaViewer.listenKeys).
            on('keydown', AdaliaViewer.listenKeys);
    },


    open: function() {
        AdaliaViewer.links = [];
        // Collect and index adalia viewer links on the page.
        jQuery('[data-av="true"]').each(function(index, item) {
            AdaliaViewer.links.push(jQuery(this).attr('data-av-index', index));
        });
        // Remove scroll bar.
        jQuery('body').addClass('adalia-viewer-active');
        // Render preview for current file.
        AdaliaViewer.currentIndex = parseInt(jQuery(this).attr('data-av-index'), 10);
        AdaliaViewer.renderCurrent();
        return false;
    },


    toggleFileSelector: function() {
        jQuery('.adalia-viewer .file-selector .files').slideToggle();
        return false;
    },


    selectFile: function() {
        var newIndex = parseInt(jQuery(this).attr('data-index'), 10);
        if (newIndex != AdaliaViewer.currentIndex) {
            AdaliaViewer.currentIndex = newIndex;
            AdaliaViewer.renderCurrent();
        }
        return false;
    },


    renderCurrent: function() {
        var link = this.links[this.currentIndex];
        var originalUrl = link.attr('href');
        var downloadUrl = originalUrl + (originalUrl.match(/\?/) ? '&' : '?') + 'download=true';
        var contentType = link.attr('data-av-content-type');
        var viewerType = 'other';
        var showDownloadLink = (link.attr('data-av-show-download-link') !== 'false');


        var fetchDownloadToken = true; //jQuery('body').attr('data-av-token');

        if (this.ContentTypes.isViewableImage(contentType)) {
            viewerType = 'image';
        } else if (this.ContentTypes.isViewableHtmlDocument(contentType)) {
            viewerType = 'html';
        } else if (this.ContentTypes.isViewableDocument(contentType)) {
            viewerType = 'document';
        }

        var renderPreview = function(token){
          // Render content depending on the type of file.
          switch (viewerType) {
            // Documents that are available as PDF.
            case 'document':
                var url = originalUrl + (originalUrl.match(/\?/) ? '&' : '?') + 'pdf=true';
                jQuery('.adalia-viewer .content').html(AdaliaViewer.Templates.loading() + AdaliaViewer.Templates.iframe({
                    src: '/pdfjs/web/viewer.html?v=1.8.188&file=' + encodeURIComponent(url) + encodeURIComponent('&token=' + token) +  '#zoom=page-width'
                })).find('iframe').load(function() {
                    jQuery(this).show().prev('.loading').remove();
                });
                break;
            // Documents that are available as HTML.
            case 'html':
                  var url = originalUrl + (originalUrl.match(/\?/) ? '&' : '?') + 'html=true&token=' + token;
                jQuery('.adalia-viewer .content').html(AdaliaViewer.Templates.loading() + AdaliaViewer.Templates.html({
                    src: url
                })).find('iframe').load(function () {
                    AdaliaViewer.HtmlDocument.renderHtmlDocument(this);
                    jQuery(this).show().prev('.loading').remove();
                });
                break;
            // Images that the browser can handle directly. Other types are converted to .png
            case 'image':
                var url = originalUrl + (originalUrl.match(/\?/) ? '&' : '?') + 'viewer=true&token=' + token;
                jQuery('.adalia-viewer .content').html(AdaliaViewer.Templates.loading() + AdaliaViewer.Templates.image({
                    src: url
                }));
                var img = jQuery('.adalia-viewer .content .image img');
                var imageLoaded = function() {
                    var container = img.closest('.image');
                    container.show().prev('.loading').remove();
                    container.find('div').css('width', img.width() + 'px').css('height', img.height() + 'px');
                    img.remove();
                };
                if (img.get(0).complete) {
                    imageLoaded();
                } else {
                    img.load(imageLoaded).error(function() {
                        jQuery('.adalia-viewer .content').html(AdaliaViewer.Templates.error({
                            message: I18n.t('adalia_viewer_error_file_not_found')
                        }));
                    });
                }
                break;
            // Currently no support for others. Offering download.
            case 'other':
                jQuery('.adalia-viewer .content').html(AdaliaViewer.Templates.download({
                    url: downloadUrl,
                    showDownloadLink: showDownloadLink
                }));
                break;
            default:
                // nop
          }
        }


        if (fetchDownloadToken != null){
          jQuery('.adalia-viewer .content').html(AdaliaViewer.Templates.loading());
          jQuery.ajax({
            url: get_attachment_token_path(),
            success: function(data){
              renderPreview(data.token);
            } 
          })
        } else {
          renderPreview('');
        }

        // File selector.
        var files = _.map(this.links, function(l, index) {
            return {title: l.attr('data-av-title') || l.text(), index: index};
        });
        jQuery('.adalia-viewer .header .title').html(this.Templates.fileSelector({
            currentFile: files[this.currentIndex],
            files: files
        }));

        jQuery(".adalia-viewer .actions .download").toggle(showDownloadLink);

        // Hide prev/next button if viewing the first/last file.
        jQuery('.adalia-viewer .navigation').show();

        if (this.currentIndex <= 0) {
            jQuery('.adalia-viewer .navigation.prev').hide();
        }
        if (this.currentIndex >= this.links.length - 1) {
            jQuery('.adalia-viewer .navigation.next').hide();
        }
        jQuery('.adalia-viewer .header .download').attr('href', downloadUrl);
        jQuery('.adalia-viewer').show();
    },


    close: function() {
        jQuery('.adalia-viewer').hide();
        jQuery('body').removeClass('adalia-viewer-active');
        return false;
    },


    prev: function() {
        var index = AdaliaViewer.currentIndex - 1;

        if (index < 0) {
            index = 0;
        }
        if (index != AdaliaViewer.currentIndex) {
            AdaliaViewer.currentIndex = index;
            AdaliaViewer.renderCurrent();
        }
        return false;
    },


    next: function() {
        var index = AdaliaViewer.currentIndex + 1;

        if (index > AdaliaViewer.links.length - 1) {
            index = AdaliaViewer.links.length - 1;
        }
        if (index != AdaliaViewer.currentIndex) {
            AdaliaViewer.currentIndex = index;
            AdaliaViewer.renderCurrent();
        }
        return false;
    },


    listenKeys: function(e) {
        if (jQuery('body > .adalia-viewer').is(':visible')) {
            switch (e.keyCode) {
                case 27: // Esc
                    AdaliaViewer.close();
                    break;
                case 37: // Left arrow
                    AdaliaViewer.prev();
                    break;
                case 39: // Right arrow
                    AdaliaViewer.next();
                    break;
                default:
                    // nop
            }
        }
    },


    HtmlDocument: {
        tableIds: [],
        headerIds: [],

        renderHtmlDocument: function (iframe_selector) {
            AdaliaViewer.HtmlDocument.tableIds = [];
            AdaliaViewer.HtmlDocument.headerIds = [];
            var firstSheetFound = false;
            var iframe = jQuery(iframe_selector).get(0).contentDocument;
            var styles = iframe.head.getElementsByTagName("STYLE")[0].innerHTML.replace(/"Calibri"/g, 'sans-serif');
            styles += ' center a { display: inline-block; color: #fff; background-color: #47A9A6; padding: 6px 12px; \
                border-radius: 18px; margin: 4px 3px; text-decoration: none; } \
                center a:active:focus, center a:active:hover { background-color: #337A78; }';
            iframe.head.getElementsByTagName("STYLE")[0].innerHTML = styles;
            var nodes = iframe.body.childNodes;

            Array.from(nodes).forEach(function (node) {
                switch (node.tagName) {
                    case 'A':
                        if (node.name.match(/table\d/).length > 0) {
                            if (firstSheetFound) node.style.display = "none";

                            var previousElement = node.previousElementSibling;

                            while (true) {
                                previousElement = previousElement.nextElementSibling
                                var thisElement = previousElement.nextElementSibling;
                                if (thisElement) {
                                    if (thisElement.tagName == 'TABLE') {
                                        if (firstSheetFound) thisElement.style.display = "none";
                                        thisElement.id = node.name;
                                        AdaliaViewer.HtmlDocument.tableIds.push(thisElement.id);
                                        break;
                                    }
                                } else {
                                    break;
                                }
                            }

                            node.id = node.name + '-header';
                            AdaliaViewer.HtmlDocument.headerIds.push(node.id);
                            firstSheetFound = true;
                            break;
                        }
                    case 'CENTER':
                        Array.from(node.childNodes).forEach(function (n) {
                            switch (n.tagName) {
                                case 'A':
                                    if (n.href.match(/#table\d/).length > 0) {
                                        function showSheet() {
                                            var tableId = n.href.split('#')[1];
                                            var headerId = tableId + '-header';

                                            AdaliaViewer.HtmlDocument.tableIds.forEach(function (id) {
                                                iframe.getElementById(id).style.display = "none";
                                            });

                                            AdaliaViewer.HtmlDocument.headerIds.forEach(function (id) {
                                                iframe.getElementById(id).style.display = "none";
                                            });

                                            iframe.getElementById(tableId).style.display = "inline";
                                            iframe.getElementById(headerId).style.display = "inline";
                                            return false;
                                        }

                                        n.onclick = showSheet;
                                    }
                                    break;
                                case 'BR':
                                    n.parentElement.removeChild(n);
                                    break;
                                case 'H1':
                                    n.innerHTML = I18n.t('sheets');
                                    break;
                                default:
                            }
                        });
                        break;
                    case 'IMG':
                        node.style.display = "none";
                        break;
                    case 'HR':
                        if (firstSheetFound) node.style.display = "none";
                        break;
                    default:
                }
            });
        }
    },


    ContentTypes: {
        isViewableDocument: function(contentType) {
            return this.isAllowedType(this.document, contentType);
        },

        isViewableHtmlDocument: function (contentType) {
            return this.isAllowedType(this.html, contentType);
        },

        isViewableImage: function(contentType) {
            return this.isAllowedType(this.image, contentType);
        },

        isAllowedType: function(allowedTypes, contentType) {
            return _.findIndex(allowedTypes, function(allowedType) {
                return (contentType == allowedType || contentType.match(new RegExp(allowedType.replace('/', '\\/').replace(/\*/g, '.*'))));
            }) != -1;
        },

        // Assuming these content types have been converted to PDF and
        // are viewable with PDF.js.
        document: [
            'application/pdf',
            'text/*',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.text-flat-xml',
            'application/vnd.oasis.opendocument.text-template',
            'application/vnd.oasis.opendocument.text-web',
            'application/vnd.oasis.opendocument.text-master',
            'application/vnd.oasis.opendocument.presentation',
            'application/vnd.oasis.opendocument.presentation-flat-xml',
            'application/vnd.oasis.opendocument.presentation-template',
            'application/rtf',
            'application/msword',
            'application/vnd.ms-powerpoint',
            'application/vnd.stardivision.writer',
            'application/vnd.sun.xml.impress',
            'application/vnd.sun.xml.impress.template',
            'application/vnd.sun.xml.writer',
            'application/vnd.sun.xml.writer.global',
            'application/vnd.sun.xml.writer.template',
            'application/vnd.wordperfect',
            'application/vnd.lotus-wordpro',
            'application/vnd.openofficeorg.extension',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-word.document.macroenabled.12',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.ms-word.template.macroenabled.12',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint.presentation.macroenabled.12',
            'application/vnd.openxmlformats-officedocument.presentationml.template',
            'application/vnd.ms-powerpoint.template.macroenabled.12'
        ],

        // Converted to HTML
        html: [
            'text/html',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.spreadsheet-flat-xml',
            'application/vnd.oasis.opendocument.spreadsheet-template',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel.sheet.macroenabled.12',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
            'application/vnd.ms-excel.template.macroenabled.12',
            'application/vnd.ms-excel.sheet.binary.macroenabled.12'
        ],

        // Unsupported types are converted to .png
        image: [
            'image/*'
        ]
    },


    Templates: {
        viewer: _.template(`
            <div class="adalia-viewer" style="display: none;">
                <div class="overlay"></div>
                <div class="header">
                    <div class="title">
                    </div>
                    <div class="actions">
                        <a href="#" class="download" title="<%= I18n.t('download') %>" data-turbo="false"><i class="fa fa-download"></i></a>
                        <a href="#" class="close" title="<%= I18n.t('close') %>"><i class="fa fa-close"></i></a>
                    </div>
                </div>
                <div class="content">
                    <%= AdaliaViewer.Templates.loading() %>
                </div>
                <div class="navigation prev">
                    <a href="#"><i class="fa fa-angle-left"></i></a>
                </div>
                <div class="navigation next">
                    <a href="#"><i class="fa fa-angle-right"></i></a>
                </div>
            </div>
        `),

        fileSelector: _.template(`
            <div class="file-selector">
                <a href="#" class="current">
                    <%= currentFile.title %>
                    <i class="fa fa-caret-down"></i>
                </a>
                <div class="files" style="display: none;">
                    <ul>
                        <% for (var i = 0; i < files.length; i++) { %>
                            <li class="<%= currentFile.index == files[i].index ? 'current' : '' %>">
                                <a href="#" data-index="<%= files[i].index %>"><%= files[i].title %></a>
                            </li>
                        <% } %>
                    </ul>
                </div>
            </div>
        `),

        iframe: _.template(`
            <iframe src="<%= src %>" style="display: none;"></iframe>
        `),

        html: _.template(`
            <iframe src="<%= src %>" class="html" style="display: none;"></iframe>
        `),

        image: _.template(`
            <div class="image" style="display: none;">
              <div style="background-image: url(<%= src %>)" />
              <img src="<%= src %>" />
            </div>
        `),

        loading: _.template(`
            <div class="loading"><i class="fa fa-gear fa-spin"></i></div>
        `),

        error: _.template(`
            <div class="message"><p><%= message %></p></div>
        `),

        download: _.template(`
            <div class="message">
                <p>
                    <%= I18n.t('adalia_viewer_other_type_download_message') %><br />
                    <% if (showDownloadLink) { %>
                      <a href="<%= url %>" data-turbo="false"><i class="fa fa-download"></i> <%= I18n.t('adalia_viewer_download') %></a>
                    <% } %>
                </p>
            </div>
        `)
    }
};

export default AdaliaViewer;